import { useToastedMutation } from '../../../ReactQuery';
import { remove } from '../../../redux/api';
import { nuc } from '../../../utils';

const deleteDependency = async (parentLocator: string, dependencyLocator: string) => {
  await remove(`/api/revisions/${nuc(parentLocator)}/dependencies/${nuc(dependencyLocator)}`);
};

/**
 * Hook for deleting a manual dependency within a user project.
 */
export default function useDeleteDependency(parentLocator: string) {
  return useToastedMutation({
    mutationFn: async (dependencyLocator: string) => deleteDependency(parentLocator, dependencyLocator),
    successToastMessage: 'Manual dependency deleted successfully.',
    errorToastMessage: 'Failed to delete manual dependency.',
  });
}
